
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { AccountingPlanSetupModel } from 'models/generated/Entities.Accounting.AccountingPlanSetup';


const _accounting_AccountingPlanSetupControllerHelper = new Map<string, Object>();
_accounting_AccountingPlanSetupControllerHelper.set('GetAccountingPlanSetups', AccountingPlanSetupModel);
_accounting_AccountingPlanSetupControllerHelper.set('UpdateAccountingPlanSetup', AccountingPlanSetupModel);
_accounting_AccountingPlanSetupControllerHelper.set('CreateAccountingPlanSetup', AccountingPlanSetupModel);
_accounting_AccountingPlanSetupControllerHelper.set('DeleteAccountingPlanSetup', AccountingPlanSetupModel);


export const accounting_AccountingPlanSetupControllerHelper = _accounting_AccountingPlanSetupControllerHelper;

